import React from "react";
import { Space, Typography } from "antd";
import { CreditCardOutlined } from "@ant-design/icons";

const { Text } = Typography;

const SubscriptionDrawerPaymentInfo = ({ last4 }) => (
  <Space>
    <CreditCardOutlined />
    <Text type="secondary">{last4 || "—"}</Text>
  </Space>
);


export default SubscriptionDrawerPaymentInfo;